"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionExplainer = void 0;
const merlin_spacer_1 = require("@travelnest/merlin.spacer");
const react_1 = __importDefault(require("react"));
const CommissionExplainer_styled_1 = require("./CommissionExplainer.styled");
const DEFAULT_GRADIENT = 'linear-gradient(#3769ED, #269FC1, #03AB97)';
const CommissionExplainer = (props) => {
    var _a;
    const tnFee = props.tnFeeRate * 100;
    const channelFee = props.channelFeeRate * 100;
    return react_1.default.createElement(CommissionExplainer_styled_1.StyledCommissionFeesPanel, { bgColor: props.bgColor, background: (_a = props.background) !== null && _a !== void 0 ? _a : DEFAULT_GRADIENT, "data-testid": 'commission-explainer-root' },
        react_1.default.createElement(CommissionExplainer_styled_1.CentredFlex, null,
            react_1.default.createElement(CommissionExplainer_styled_1.HeadingNumberPrimary, null,
                tnFee,
                "%"),
            react_1.default.createElement("div", null,
                react_1.default.createElement(CommissionExplainer_styled_1.CommissionPanelHeader, null, "TravelNest Fee"),
                react_1.default.createElement(CommissionExplainer_styled_1.ExplainerBody, null,
                    "We keep things simple with a ",
                    tnFee,
                    "% TravelNest Fee per booking."))),
        react_1.default.createElement(merlin_spacer_1.Spacer, null),
        react_1.default.createElement(merlin_spacer_1.HorizontalRule, null),
        react_1.default.createElement(merlin_spacer_1.Spacer, null),
        react_1.default.createElement(CommissionExplainer_styled_1.CentredFlex, null,
            react_1.default.createElement(CommissionExplainer_styled_1.HeadingNumberSecondary, null,
                "+",
                channelFee,
                "%"),
            react_1.default.createElement("div", null,
                react_1.default.createElement(CommissionExplainer_styled_1.ExplainerBody, null, "Our Channel Fee covers ALL channel commissions and guest payment processing."))));
};
exports.CommissionExplainer = CommissionExplainer;
//# sourceMappingURL=CommissionExplainer.js.map